import { useMemo } from 'react';
import styles from './index.module.scss';
import { getTableQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import {
  DEFAULT_QUERY_PARAM_TABLE_IDENTIFIER,
  MAX_WIDTH_SELECTED_FILTERS_DISPLAY
} from './constants';
import { ISelectedFilters } from './types';
import cx from 'classnames';
import { useFilterDrawerLogic } from './hooks/useFilterDrawerLogic';
import VerticalSeperator from '../VerticalSeperator';
import FilterItem from './FilterItem';

const SelectedFilters = (props: ISelectedFilters) => {
  const {
    filterSchemaMap,
    filterSchema,
    handleFilterChange,
    clearAllFilters,
    queryParamTableIdentifier = DEFAULT_QUERY_PARAM_TABLE_IDENTIFIER,
    customClassname = '',
    onMoreFiltersClick,
    maxWidth = MAX_WIDTH_SELECTED_FILTERS_DISPLAY
  } = props;
  const CLEAR_ALL_FILTERS_COUNT = 1;
  const queryParams = getTableQueryParams(filterSchema, queryParamTableIdentifier, true);

  const handleCancelIconClick = (filterKey: string) => {
    handleFilterChange(filterKey);
  };

  const filterDisplayResult = useFilterDrawerLogic({
    filterSchema,
    queryParams,
    filterSchemaMap,
    maxWidth
  });

  const { displayedFilters, hiddenFilters, activeFiltersCount, isEmpty } = filterDisplayResult;

  const renderSelectedFilters = useMemo(() => {
    if (isEmpty) {
      return null;
    }

    const displayedFilterElements = displayedFilters.map(filter => {
      if (!filter) return null;
      return <FilterItem key={filter.filterKey} filter={filter} onRemove={handleCancelIconClick} />;
    });

    return (
      <>
        {activeFiltersCount > CLEAR_ALL_FILTERS_COUNT ? (
          <Button variant="text" className="underline mr-1" onClick={() => clearAllFilters(true)}>
            Clear All
          </Button>
        ) : null}
        {hiddenFilters.length > 0 && (
          <>
            <VerticalSeperator color="var(--blue-base)" height="12px" />
            <Button
              variant="text"
              color="var(--blue-base)"
              onClick={() => {
                onMoreFiltersClick?.();
              }}
            >
              +{hiddenFilters.length} more
            </Button>
          </>
        )}

        {displayedFilterElements}
      </>
    );
  }, [displayedFilters, hiddenFilters, activeFiltersCount, isEmpty]);

  return (
    <div className={cx(styles.selectedFiltersWrapper, customClassname)}>
      {renderSelectedFilters}
    </div>
  );
};

export default SelectedFilters;
